import { render } from "./BranchDot.vue?vue&type=template&id=71649164"
import script from "./BranchDot.vue?vue&type=script&lang=js"
export * from "./BranchDot.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__